"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateHeading = exports.DisabledWarningBanner = exports.AppointmentPurposeSelect = exports.LocationSelect = exports.RadioButtonGroup = exports.AppointmentInfoContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const select_1 = require("@kyruus/select");
const radio_1 = __importDefault(require("@kyruus/radio"));
const banner_1 = __importDefault(require("@kyruus/banner"));
exports.AppointmentInfoContainer = styled_1.default.div `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
`;
exports.RadioButtonGroup = (0, styled_1.default)(radio_1.default) `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  margin-inline-start: 0;
  margin-inline-end: 0;

  > div {
    gap: 0;
    > div {
      flex-basis: 100%;

      &:first-of-type {
        label {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      &:last-of-type {
        label {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }
  }
  > legend {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    text-indent: 0;
    line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  }
`;
const StyledSelect = (0, styled_1.default)(select_1.Select) `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};

  > label {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
    text-indent: 0;
    padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  }
  button {
    border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  }
`;
exports.LocationSelect = (0, styled_1.default)(StyledSelect) ``;
exports.AppointmentPurposeSelect = (0, styled_1.default)(StyledSelect) `
  button {
    &.changed {
      @keyframes placeHolderShimmer {
        0% {
          background-position: -468px 0;
        }
        100% {
          background-position: 468px 0;
        }
      }

      animation-duration: 1.8s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: placeHolderShimmer;
      animation-timing-function: linear;
      background: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
      background: linear-gradient(
        to right,
        ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 10%,
        ${(0, ui_theme_1.fromTheme)('color_button_secondary_hover')} 18%,
        ${(0, ui_theme_1.fromTheme)('color_button_secondary')} 33%
      );
      background-color: ${(0, ui_theme_1.fromTheme)('color_item_hover')};
      background-size: 1000px 640px;
    }
  }
`;
exports.DisabledWarningBanner = (0, styled_1.default)(banner_1.default) `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
`;
exports.DateHeading = (0, styled_1.default)('h3') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_large')} 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
//# sourceMappingURL=styles.js.map